(function () {
  'use strict';

  var MOBILE_BREAKPOINT = 750;

  function initCarrosselVideosProduto(section) {
    if (section.dataset.cvpInitialized === 'true') return;
    section.dataset.cvpInitialized = 'true';

    var track = section.querySelector('[data-cvp-track]');
    var viewport = section.querySelector('[data-cvp-viewport]');
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-cvp-item]'));
    var prevButtons = Array.prototype.slice.call(
      section.querySelectorAll('[data-cvp-prev], [data-cvp-prev-side]')
    );
    var nextButtons = Array.prototype.slice.call(
      section.querySelectorAll('[data-cvp-next], [data-cvp-next-side]')
    );
    var openButtons = Array.prototype.slice.call(section.querySelectorAll('[data-cvp-open]'));
    var modal = section.querySelector('[data-cvp-modal]');
    var modalVideo = section.querySelector('[data-cvp-modal-video]');
    var modalPrev = section.querySelector('[data-cvp-modal-prev]');
    var modalNext = section.querySelector('[data-cvp-modal-next]');
    var closeTriggers = Array.prototype.slice.call(section.querySelectorAll('[data-cvp-close]'));
    var desktopVisible = parseInt(section.dataset.desktopVisible, 10) || 4;
    var currentIndex = 0;
    var modalIndex = 0;
    var lastFocused = null;
    var suppressClick = false;

    if (!track || !items.length || !viewport) return;

    function isMobile() {
      return window.innerWidth < MOBILE_BREAKPOINT;
    }

    function getVisibleCount() {
      if (isMobile()) return 1;
      return Math.min(items.length, desktopVisible);
    }

    function getMaxIndex() {
      return Math.max(0, items.length - getVisibleCount());
    }

    function clampIndex(index) {
      return Math.max(0, Math.min(index, getMaxIndex()));
    }

    function getGap() {
      return parseFloat(getComputedStyle(track).gap) || 0;
    }

    function getItemStep() {
      if (!items[0]) return 0;
      return items[0].offsetWidth + getGap();
    }

    function updateItemWidths() {
      if (isMobile()) {
        section.style.removeProperty('--cvp-item-width');
        return;
      }

      var visible = getVisibleCount();
      var gap = getGap();
      var viewportWidth = viewport.offsetWidth;
      var totalGap = gap * Math.max(0, Math.floor(visible) - 1);
      var itemWidth = (viewportWidth - totalGap) / visible;
      section.style.setProperty('--cvp-item-width', itemWidth + 'px');
    }

    function updateTrack() {
      if (isMobile()) {
        track.style.transform = '';
        return;
      }

      track.style.transform = 'translateX(-' + currentIndex * getItemStep() + 'px)';
    }

    function getMobileIndexFromScroll() {
      var step = getItemStep();
      if (!step) return 0;
      return clampIndex(Math.round(viewport.scrollLeft / step));
    }

    function updateNav() {
      var index = isMobile() ? getMobileIndexFromScroll() : currentIndex;
      var disabledPrev = index <= 0;
      var disabledNext = index >= getMaxIndex();

      prevButtons.forEach(function (button) {
        button.disabled = disabledPrev;
      });

      nextButtons.forEach(function (button) {
        button.disabled = disabledNext;
      });
    }

    function scrollMobileTo(index, smooth) {
      var target = clampIndex(index);
      var left = target * getItemStep();

      viewport.scrollTo({
        left: left,
        behavior: smooth === false ? 'auto' : 'smooth'
      });

      currentIndex = target;
      updateNav();
    }

    function goTo(index) {
      currentIndex = clampIndex(index);

      if (isMobile()) {
        scrollMobileTo(currentIndex, true);
        return;
      }

      updateTrack();
      updateNav();
    }

    function refresh() {
      updateItemWidths();

      if (isMobile()) {
        currentIndex = getMobileIndexFromScroll();
        track.style.transform = '';
        updateNav();
        return;
      }

      viewport.scrollLeft = 0;
      currentIndex = clampIndex(currentIndex);
      updateTrack();
      updateNav();
    }

    function getPlayableItems() {
      return items.filter(function (item) {
        return Boolean(item.dataset.videoSrc);
      });
    }

    function updateModalNav() {
      var playable = getPlayableItems();
      if (!modalPrev || !modalNext) return;

      modalPrev.disabled = playable.length <= 1;
      modalNext.disabled = playable.length <= 1;
    }

    function loadModalVideo(index) {
      var playable = getPlayableItems();
      if (!playable.length || !modalVideo) return;

      modalIndex = ((index % playable.length) + playable.length) % playable.length;
      var item = playable[modalIndex];
      var src = item.dataset.videoSrc || '';
      var poster = item.dataset.posterSrc || '';

      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.load();

      if (poster) {
        modalVideo.setAttribute('poster', poster);
      } else {
        modalVideo.removeAttribute('poster');
      }

      modalVideo.src = src;
      modalVideo.load();

      var playPromise = modalVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }

      updateModalNav();
    }

    function openModal(item) {
      var playable = getPlayableItems();
      if (!modal || !modalVideo || !item || !item.dataset.videoSrc) return;

      var playableIndex = playable.indexOf(item);
      if (playableIndex < 0) return;

      lastFocused = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('cvp-modal-open');
      loadModalVideo(playableIndex);

      var closeBtn = modal.querySelector('[data-cvp-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      if (!modal || modal.hidden) return;

      if (modalVideo) {
        modalVideo.pause();
        modalVideo.removeAttribute('src');
        modalVideo.load();
      }

      modal.hidden = true;
      document.body.classList.remove('cvp-modal-open');

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function stepModal(delta) {
      loadModalVideo(modalIndex + delta);
    }

    prevButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = isMobile() ? getMobileIndexFromScroll() : currentIndex;
        goTo(index - 1);
      });
    });

    nextButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var index = isMobile() ? getMobileIndexFromScroll() : currentIndex;
        goTo(index + 1);
      });
    });

    openButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        if (suppressClick) {
          event.preventDefault();
          event.stopPropagation();
          suppressClick = false;
          return;
        }

        var item = button.closest('[data-cvp-item]');
        openModal(item);
      });
    });

    closeTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', closeModal);
    });

    if (modalPrev) {
      modalPrev.addEventListener('click', function () {
        stepModal(-1);
      });
    }

    if (modalNext) {
      modalNext.addEventListener('click', function () {
        stepModal(1);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (!modal || modal.hidden) return;

      if (event.key === 'Escape') {
        closeModal();
      } else if (event.key === 'ArrowLeft') {
        stepModal(-1);
      } else if (event.key === 'ArrowRight') {
        stepModal(1);
      }
    });

    var scrollTimer;
    viewport.addEventListener('scroll', function () {
      if (!isMobile()) return;
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        currentIndex = getMobileIndexFromScroll();
        updateNav();
      }, 60);
    }, { passive: true });

    var pointerStartX = 0;
    var pointerDeltaX = 0;
    var pointerActive = false;

    viewport.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerActive = true;
      pointerStartX = event.clientX;
      pointerDeltaX = 0;
      suppressClick = false;
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!pointerActive) return;
      pointerDeltaX = event.clientX - pointerStartX;
      if (Math.abs(pointerDeltaX) > 12) {
        suppressClick = true;
      }
    });

    function endPointer() {
      if (!pointerActive) return;
      pointerActive = false;

      if (isMobile()) {
        // Native scroll handles mobile swipe; only suppress accidental opens.
        return;
      }

      if (Math.abs(pointerDeltaX) < 40) return;
      if (pointerDeltaX < 0) goTo(currentIndex + 1);
      else goTo(currentIndex - 1);
    }

    viewport.addEventListener('pointerup', endPointer);
    viewport.addEventListener('pointercancel', endPointer);

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refresh, 150);
    });

    if (modal) {
      var modalTouchStartX = 0;
      var modalTouchDeltaX = 0;

      modal.addEventListener('touchstart', function (event) {
        if (modal.hidden) return;
        modalTouchStartX = event.touches[0].clientX;
        modalTouchDeltaX = 0;
      }, { passive: true });

      modal.addEventListener('touchmove', function (event) {
        if (modal.hidden) return;
        modalTouchDeltaX = event.touches[0].clientX - modalTouchStartX;
      }, { passive: true });

      modal.addEventListener('touchend', function () {
        if (modal.hidden) return;
        if (Math.abs(modalTouchDeltaX) < 50) return;
        if (modalTouchDeltaX < 0) stepModal(1);
        else stepModal(-1);
      });
    }

    refresh();
  }

  function initAll() {
    document.querySelectorAll('[data-cvp]').forEach(initCarrosselVideosProduto);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-cvp]');
    if (section) {
      section.dataset.cvpInitialized = 'false';
      initCarrosselVideosProduto(section);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-cvp]');
    if (!section) return;

    var modalVideo = section.querySelector('[data-cvp-modal-video]');
    if (modalVideo) {
      modalVideo.pause();
      modalVideo.removeAttribute('src');
    }

    document.body.classList.remove('cvp-modal-open');
  });
})();
